import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ToastContainer
      Colored
      theme="colored"
      closeButton={false}
      autoClose={4000}
      id="general"
    />
    <HelmetProvider>
      <div style={{ paddingTop: "66px" }}>
        <App />
      </div>
    </HelmetProvider>
  </React.StrictMode>,
);
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/Service-worker.js")
      .then((registration) => {
        console.log("✅ SW registered:", registration);
      })
      .catch((error) => {
        console.log("❌ SW registration failed:", error);
      });
  });
}
reportWebVitals();
